import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import { mapGetters } from 'vuex'
import router from '@/router'

export default {
  computed: {
    ...mapGetters({
      portalConfigurations: 'tenantDesign/config'
    })
  },
  methods: {
    initGoogleAnalytics (isLanding) {
      if (!this.portalConfigurations.integrations) {
        return
      }

      if (isLanding && !this.portalConfigurations.integrations.landingGoogleAnalyticsTrackingId) {
        return
      }

      if (!isLanding && !this.portalConfigurations.integrations.portalGoogleAnalyticsTrackingId) {
        return
      }

      let trackingId = ''
      if (isLanding) {
        trackingId = this.portalConfigurations.integrations.landingGoogleAnalyticsTrackingId
      } else {
        trackingId = this.portalConfigurations.integrations.portalGoogleAnalyticsTrackingId
      }
      if (!trackingId) {
        return
      }

      // const isProd = process.env.NODE_ENV === 'production'

      Vue.use(VueAnalytics, {
        id: trackingId,
        router,
        debug: {
          enabled: false,
          sendHitTask: true
        }
      })
    }
  }
}
